module.exports = __webpack_public_path__ + "img/5.33d3bfcf.png";